import { AnimatePresence } from "framer-motion";
import React from "react";
import useDeviceType from "../../hook/useDeviceType";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Menu from "./Menu";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { CloseMenu } from "../../redux/action/action";
import { COMMON_WEB_PATH } from "../../constant";
import useWebsiteInfo from "../../hook/useWebsiteInfo";

const MenuItem = ({ icon1, icon2, text, isActive, onClick }) => {
  const [isHover, setIsHover] = React.useState(false);

  return (
    <Flex
      alignItems="center"
      p="25px"
      cursor="pointer"
      transition="all 0.3s ease"
      sx={{
        '&:hover, &[data-active="true"]': {
          bgImage: `url('${icon1.split("/menu/")[0]}/menu/activeBG.webp')`,
          bgSize: "contain",
          bgRepeat: "no-repeat",
          bgPosition: "center",
        },
      }}
      data-active={isActive}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={onClick}
      maxW="150px"
      w="100%" // 確保Flex佔滿寬度
      position="relative"
    >
      <Image
        p="5px"
        src={isHover || isActive ? icon2 : icon1}
        w={{
          base: "80px",
          md: "80px",
          lg: "90px",
          xl: "90px",
        }}
      />
      {/* <Text
        color="white"
        fontSize="16px"
        fontWeight={isActive ? "bold" : "normal"}
      >
        {text}
      </Text> */}
    </Flex>
  );
};

const LobbyMenu = ({ activeMenu, onMenuChange }) => {
  // const [activeMenu, setActiveMenu] = React.useState("exclusive");
  const deviceType = useDeviceType();
  const { getMenuIconPath, images } = useWebsiteInfo();

  const menuItems = [
    {
      id: "hot",
      text: "熱門",
      icon1: getMenuIconPath("hot", false),
      icon2: getMenuIconPath("hot", true),
    },
    /*
    {
      id: "exclusive",
      text: "獨家",
      icon1: getMenuIconPath("exclusive", false),
      icon2: getMenuIconPath("exclusive", true),
    },
    */

    {
      id: "new",
      text: "最新",
      icon1: getMenuIconPath("new", false),
      icon2: getMenuIconPath("new", true),
    },
  ];

  return (
    <Box w="100%" h="auto" position="fixed" marginTop={"400px"}>
      <Flex
        direction="column"
        minH="200px"
        justify="space-between"
        bgImage={`url('${COMMON_WEB_PATH}/911TW/menu/rightMenuBG.webp')`}
        bgSize="contain"
        bgRepeat="no-repeat"
      >
        {menuItems.map((item) => (
          <MenuItem
            key={item.id}
            icon1={item.icon1}
            icon2={item.icon2}
            //text={item.text}
            isActive={activeMenu === item.id}
            onClick={() => onMenuChange(item.id)} //把狀態提升到了父組件 HomeV4 中，子組件 LobbyMenu 不再直接管理這個狀態，而是通過 props 接收狀態和更新函數
          />
        ))}
      </Flex>
    </Box>
  );
};

export default LobbyMenu;
